module.exports = __webpack_public_path__ + "20221216:03503e97ddf972ec7716/img/hero-mobile@1x.56b3778.jpg";